import { S } from '@/shared/constants/styles';
import { useIsMobile } from '@/shared/hooks/useMediaQuery';

export default function Pagination({
  page, totalPages, hasNext, hasPrev,
  onNext, onPrev,
  rangeStart, rangeEnd, totalItems,
  theme: t, mode = 'paginated',
}) {
  const mobile = useIsMobile();

  if (totalItems <= (mobile ? 25 : 50)) return null;

  if (mode === 'loadMore' && hasNext) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
        <button
          onClick={onNext}
          style={{
            ...S.btn('#64748b'),
            width: '100%',
            maxWidth: 320,
            textAlign: 'center',
          }}
        >
          Load More ({rangeEnd} of {totalItems})
        </button>
      </div>
    );
  }

  if (mode === 'paginated') {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '14px 16px',
        fontSize: 12,
        color: t.textMuted,
      }}>
        <span>
          {rangeStart}-{rangeEnd} of {totalItems}
        </span>
        <div style={{ display: 'flex', gap: 6 }}>
          <button
            onClick={onPrev}
            disabled={!hasPrev}
            style={{
              ...S.btnSm(hasPrev ? '#2563eb' : '#94a3b8'),
              opacity: hasPrev ? 1 : 0.4,
              cursor: hasPrev ? 'pointer' : 'default',
              minWidth: 32,
            }}
            aria-label="Previous page"
          >
            {'<'}
          </button>
          <span style={{ display: 'flex', alignItems: 'center', padding: '0 8px', fontSize: 12, fontWeight: 600, color: t.text }}>
            {page} / {totalPages}
          </span>
          <button
            onClick={onNext}
            disabled={!hasNext}
            style={{
              ...S.btnSm(hasNext ? '#2563eb' : '#94a3b8'),
              opacity: hasNext ? 1 : 0.4,
              cursor: hasNext ? 'pointer' : 'default',
              minWidth: 32,
            }}
            aria-label="Next page"
          >
            {'>'}
          </button>
        </div>
      </div>
    );
  }

  return null;
}
